import { makeAutoObservable } from 'mobx';
import moment from 'moment';
import Constants from '../../utils/constants';

class TimeState {
  time = moment().unix();
  timeshift: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setTime(date: number, force: boolean = false) {
    if (!force && date < this.currentTime) return;
    this.time = date;
    this.timeshift = 0;
  }

  get currentTime() {
    return this.time + Constants.timeshiftSize * this.timeshift;
  }

  get today() {
    return moment.unix(this.currentTime).utc().startOf('day').unix();
  }

  incrementTimeshift() {
    this.timeshift += 1;
  }
}

export default new TimeState();
